<template>
  <div>
    <UIProgressCircular v-show="!dataLoaded" />

    <div v-show="dataLoaded" class="mt-4">
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="pa-4 base-card z-10 d-flex justify-space-between align-center">
            <ButtonGoTo
              location="/spm/events/eventsPage"
              :title="'К списку<br> мероприятий'"
            />

            <h3 v-if="!$vuetify.breakpoint.xs">
              События
            </h3>

            <div class="d-flex">
              <ButtonOutlineSmall
                v-if="isAdmin"
                title="Добавить"
                icon="plus"
                @click="dialog = true"
              />

              <ButtonIconSmall
                v-if="!isXs || (isXs && isShowTable)"
                class="ml-2"
                :icon="isShowTable ? 'grid-icon' : 'menu-icon'"
                @click="switchShowTable"
              />

              <ButtonIconSmall
                v-if="!$vuetify.breakpoint.xs"
                class="ml-2"
                icon="filter"
                title="Фильтр"
                @click="showFilter"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-show="isShowFilter || !isFiltersEmpty"
        class="my-0 mt-4"
      >
        <v-col cols="12" class="pt-0 pb-0">
          <EventPartFilter
            :show-filter="isShowFilter"
            @setFilters="setFilters"
          />
        </v-col>
      </v-row>

      <v-row v-if="isShowTable" class="my-0 mt-4">
        <v-col cols="12" class="pt-0">
          <v-card ref="mainCard" class="base-card pb-4 px-4">
            <v-data-table
              ref="table"
              v-scroll.self="tableScroll"
              class="elevation-0"
              :class="isXs ? 'mobile-table' : 'base-table'"
              :loading="tableLoading"
              :headers="tableHeaders"
              :items="eventPartList.list"
              :items-per-page="-1"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-results-text="Не найдено"
              hide-default-footer
              fixed-header
            >
              <template #[`item.actions`]="{ item }">
                <!--                <a :href="'https://10.1.20.36/room/' + item.event.id + '-' + item.id">-->
                <!--                  <v-icon :class="isOperatorRoles ? 'mr-4' : ''" class="uikit-icon camera show-btn" title="Стрим" />-->
                <!--                </a>-->
                <v-icon
                  v-if="item.eventSessionId"
                  class="uikit-icon camera show-btn"
                  title="Вебинар"
                  :class="isOperatorRoles ? 'mr-4' : ''"
                  @click="goToWebinar(item)"
                />
                <v-icon
                  v-if="isAdmin"
                  class="mr-4 uikit-icon edit-icon edit-btn"
                  title="Редактировать"
                  @click="edit(item)"
                />
                <v-icon
                  v-if="isAdmin"
                  class="uikit-icon trash remove-btn"
                  title="Удалить"
                  @click="remove(item)"
                />
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-list
        v-else
        ref="list"
        v-scroll.self="tableScroll"
        class="px-4 pt-0 transparent overflow-auto"
      >
        <v-row v-if="eventPartList.list.length" class="my-0 mt-4">
          <v-col
            v-for="(item) of eventPartList.list"
            :key="item.id"
            cols="12" sm="6" lg="4" xl="3"
            class="pt-0 d-flex"
            :class="$vuetify.breakpoint.xs ? 'px-0' : ''"
          >
            <v-card class="base-card hover-card pb-4 px-4 w-full">
              <v-card-title class="d-flex justify-space-between">
                <span>{{ item.name }}</span>
              </v-card-title>
              <v-card-text>
                <div><strong>Время начала:</strong> {{ item.dateTimeFromText }}</div>
                <div class="mt-2">
                  <strong>Время окончания:</strong> {{ item.dateTimeToText }}
                </div>

                <div class="mt-2">
                  <strong>Площадка:</strong> {{ item.location && item.location.name }}
                </div>
                <div class="mt-2">
                  <strong>Тип:</strong> {{ item.eventPartType && item.eventPartType.name }}
                </div>
                <div class="mt-2">
                  <strong>Лектор:</strong> {{ item.lector }}
                </div>
                <div class="mt-2">
                  <strong>Тема:</strong> {{ item.theme }}
                </div>

                <div class="mt-2 d-flex justify-end">
                  <!--                  <a :href="'https://10.1.20.36/room/' + item.event.id + '-' + item.id">-->
                  <!--                    <v-icon :class="isOperatorRoles ? 'mr-4' : ''" class="uikit-icon camera success-h" title="Стрим" />-->
                  <!--                  </a>-->
                  <v-icon
                    v-if="item.eventSessionId"
                    class="uikit-icon camera show-btn"
                    title="Вебинар"
                    :class="isOperatorRoles ? 'mr-4' : ''"
                    @click="goToWebinar(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="mr-4 uikit-icon edit-icon primary-h"
                    title="Редактировать"
                    @click="edit(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon trash error-h"
                    title="Удалить"
                    @click="remove(item)"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else class="my-0 mt-4 justify-center">
          Данных нет
        </v-row>

        <v-progress-linear
          v-if="tableLoading"
          indeterminate
          height="2"
          class="px-4"
        />
      </v-list>
    </div>

    <EventPartDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @saveEventPart="saveEventPart"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeEvent"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import EventPartDialog from '@/components/Spm/Events/EventPartsPage/dialogs/EventPartDialog'
import {
  EventPartList,
  EventPartFilters,
} from '@/models'
import { eventPartApi, webinarApi } from '@/api'
import {
  cloneDeep,
  debounce, throttle,
} from 'lodash'
import {
  mapActions,
  mapGetters,
} from 'vuex'
import EventPartFilter from '@/components/Spm/Events/EventPartsPage/filters/EventPartFilter'
import ButtonGoTo from '@/featureSlicedDesign/features/ButtonGoTo'
import ButtonOutlineSmall from '@/featureSlicedDesign/shared/ui/ButtonOutlineSmall'
import ButtonIconSmall from '@/featureSlicedDesign/shared/ui/ButtonIconSmall'

export default {
  name: 'EventsPage',

  metaInfo: { title: 'События' },

  components: {
    ButtonIconSmall,
    ButtonOutlineSmall,
    ButtonGoTo,
    EventPartFilter,
    EventPartDialog,
    UIProgressCircular,
    ConfirmDialog,
  },

  async created() {
    await this.getEventPartList()
    this.dataLoaded = true
  },

  mounted() {
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  data: () => ({
    eventPartList: new EventPartList(),

    tableHeaders: [
      { text: 'id', value: 'id', sortable: false, align: 'start' },
      { text: 'Название', value: 'name', sortable: false, align: 'start' },
      { text: 'Время начала', value: 'dateTimeFromText', sortable: false, align: 'start', width: '160px' },
      { text: 'Время окончания', value: 'dateTimeToText', sortable: false, align: 'start', width: '160px' },
      { text: 'Площадка', value: 'location.name', sortable: false, align: 'start' },
      { text: 'Тип', value: 'eventPartType.name', sortable: false, align: 'start' },
      { text: 'Лектор', value: 'lector', sortable: false, align: 'start' },
      { text: 'Тема', value: 'theme', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'end', width: '180px' },
    ],

    pageNumber: 0,
    lastPage: false,
    total: 0,
    filters: new EventPartFilters(),

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,

    isShowFilter: false,
  }),

  computed: {
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('settings', ['isShowTable', 'isShowFullNews']),
    ...mapGetters('user', ['isOperatorRoles', 'isAdmin']),

    isFiltersEmpty() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key of Object.keys(this.filters)) {
        if (this.filters[key]) return false
      }

      return true
    },
  },

  methods: {
    ...mapActions('settings', ['setIsShowTable']),

    switchShowTable() {
      this.setIsShowTable(!this.isShowTable)
      this.setTableHeight()
    },

    showSearch() {
      this.isShowSearch = !this.isShowSearch
      this.isShowFilter = false
      this.setTableHeight()
    },

    showFilter() {
      this.isShowFilter = !this.isShowFilter
      this.isShowSearch = false
      this.setTableHeight()
    },

    async getEventPartList() {
      try {
        if (!this.lastPage) {
          this.tableLoading = true

          const { content, last, totalElements } = await eventPartApi.findAllByEventIdAndFilter(Number(this.$route.params.id), this.pageNumber, this.filters)
          if (this.pageNumber === 0) this.eventPartList = new EventPartList()
          this.lastPage = last
          this.total = totalElements
          this.pageNumber += 1

          content.length && content.forEach((obj) => this.eventPartList.add(obj))
        }
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения событий')
      } finally {
        this.tableLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async goToWebinar(item) {
      try {
        const data = await webinarApi.getOrCreateUser(item.id)
        data && window.location.replace(data.link)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка регистрации')
      }
    },

    async saveEventPart(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await eventPartApi.update(body) : await eventPartApi.create(body)

        body.id ? this.eventPartList.update(data) : this.eventPartList.add(data)
        this.$toastr('success', '', 'Событие успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeEvent() {
      try {
        this.removeLoading = true
        await eventPartApi.remove(this.selectedItem.id)
        this.eventPartList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    setTableHeight() {
      this.$nextTick(() => {
        if (this.$refs?.table) {
          const footerHeight = 67
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top

          this.$refs.table.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.list) {
          const footerHeight = 67
          const topHeight = this.$refs.list.$el.getBoundingClientRect().top

          this.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },

    tableScroll: throttle(function(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        this.getEventPartList()
      }
    }, 50),

    setFilters: debounce(async function debounceSetFilters(filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },
  },

  watch: {
    dataLoaded() {
      this.isXs && this.setIsShowTable(false)
      this.setTableHeight()
    },

    filters: {
      deep: true,
      async handler() {
        this.pageNumber = 0
        this.lastPage = false
        this.total = 0
        await this.getEventPartList()
      },
    },

    isShowFullNews() {
      this.setTableHeight()
    },

    isXs: {
      handler() {
        if (this.isXs) {
          this.setIsShowTable(false)
          this.setTableHeight()
        }
      },
    },
  },
}
</script>
